<template>
  <DBox
    :style="{
      height:
        showExchange && (vat_handling == 1 || vat_handling == 2)
          ? '240px'
          : !showExchange && (vat_handling == 1 || vat_handling == 2)
          ? '180px'
          : showExchange && vat_handling == 3
          ? '180px'
          : !showExchange && vat_handling == 3
          ? '120px'
          : '120px',
    }"
    :addButton="false"
    :addLink="false"
    :id="'cmp-accounting-sidewindow-cost_summary'"
    style="background-color: #f7fff2; padding: 0px 6px"
  >
    <div class="summary-container">
      <h4 style="padding: 20px 0px 5px; font-weight: bold; color: black">
        {{ $dft.capHead($t("summary")) }}
      </h4>
      <div class="summary-container-row">
        <div class="summary-container-row-title">
          <p>{{ $t("Net") }}</p>
        </div>
        <div class="summary-container-row-value">
          {{ $dft.curr(selectedCostsDetails.invoice.net_amount) }}
          {{ this.selectedCostsDetails.invoiceCurrency.currency_iso }}
        </div>
      </div>

      <div class="summary-container-row">
        <div class="summary-container-row-title">
          <p>{{ $t("Gross") }}</p>
        </div>
        <div class="summary-container-row-value">
          {{ $dft.curr(selectedCostsDetails.invoice.gross_amount) }}
          {{ this.selectedCostsDetails.invoiceCurrency.currency_iso }}
        </div>
      </div>
      <div
        v-if="vat_handling == 1 || vat_handling == 2"
        class="summary-container-row"
      >
        <div class="summary-container-row-title">
          <p>{{ $t("Vat1 Amount") }}</p>
        </div>
        <div class="summary-container-row-value">
          {{ $dft.curr(selectedCostsDetails.invoice.vat1_amount) }}
          {{ this.selectedCostsDetails.invoiceCurrency.currency_iso }}
        </div>
      </div>
      <div
        v-if="vat_handling == 1 || vat_handling == 2"
        class="summary-container-row"
      >
        <div class="summary-container-row-title">
          <p>{{ $t("Vat2 Amount") }}</p>
        </div>
        <div class="summary-container-row-value">
          {{ $dft.curr(selectedCostsDetails.invoice.vat1_amount) }}
          {{ this.selectedCostsDetails.invoiceCurrency.currency_iso }}
        </div>
      </div>
      <div v-if="showExchange" class="summary-container-row">
        <div class="summary-container-row-title">
          <p>{{ $t("exchangerate") }}</p>
        </div>
        <div class="summary-container-row-value">
          {{ selectedCostsDetails.invoice.exchange_rate }}
          {{ this.selectedCostsDetails.invoiceCurrency.currency_iso }}
        </div>
      </div>
      <div
        v-if="showExchange"
        class="summary-container-row"
        style="border-bottom: none"
      >
        <div class="summary-container-row-title">
          <p>{{ $t("Net System Curr") }}</p>
        </div>
        <div class="summary-container-row-value">
          {{
            $dft.curr(
              selectedCostsDetails.net_amount_sc /
                selectedCostsDetails.invoice.exchange_rate
            )
          }}
          {{ $store.getters.account.client.default_currency }}
        </div>
      </div>
    </div>
  </DBox>
</template>

<script>
import { EventHooks } from "../../../../plugins/text-field";
import { CostsService } from "../../services/costs.service";
import TaxTypesModal from "./set-tax-type-modal";
import DBox from "@dtplugins/dbox/dbox";
export default {
  components: {
    TaxTypesModal,
    DBox,
  },
  props: ["selectedCostsDetails"],
  data: function () {
    return {
      systemCurrency: "EUR",
      textFieldConfig: {
        height: 35,
        showEditIconOnHover: false,
        box: true,
        valueChangedEvent: EventHooks.OnBlur,
      },
      costVatHandling: 0,
      isTaxTypesModal: false,
      taxTypes: [],
    };
  },
  computed: {
    vat_handling: function () {
      return this.selectedCostsDetails?.invoice?.vat_handling;
    },
    showExchange: function () {
      return (
        this.selectedCostsDetails?.invoiceCurrency?.currency_iso !==
        this.$store.getters.account.client.default_currency
      );
    },
    exchangeRate() {
      if (!this.selectedCostsDetails) {
        return 0;
      }

      let exchange_rate_creation =
        Number(
          this.selectedCostsDetails.net_amount_cc /
            this.selectedCostsDetails.net_amount_sc
        ) || 0;
      return exchange_rate_creation.toFixed(2);
    },
  },
  methods: {
    onRadioChange: function (event, vat_handling_number) {
      if (vat_handling_number == 4) {
        this.onOpenTaxTypesModal();
      } else {
        CostsService.updateVatHandling(
          this.costOverview.invoice.invoice_id,
          vat_handling_number
        );
      }
    },
    onOpenTaxTypesModal() {
      this.isTaxTypesModal = true;
      CostsService.findTaxTypes().then((res) => {
        this.taxTypes = res.data.tax_types;
      });
    },
    onTaxTypeCanceled(item) {
      this.isTaxTypesModal = false;
      this.costVatHandling = this.costOverview.invoice.vat_handling || 4;
    },
    onTaxTypeSelected(item) {
      this.isTaxTypesModal = false;
      CostsService.updateInvoiceTaxType(
        this.costOverview.invoice.invoice_id,
        item.tax_type_id
      );
    },
    onInvoiceTextFieldValueChange: function (columnName, columnValue) {
      CostsService.modify_invoices(
        this.costOverview.invoice.invoice_id,
        columnName,
        columnValue
      );
    },
  },
  watch: {
    costOverview: function (n) {
      if (n) {
        this.costVatHandling = n.invoice.vat_handling || 4;
      }
    },
  },
};
</script>


<style lang="scss">
.cmp-accounting-sidewindow-cost_summary {
  margin: 20px 0px 4px 0px;
  width: 100%;
  border-radius: 6px;
  :hover {
    border: var(--bw-bd);
    border-radius: 6px;
  }
  .summary-container {
    display: flex;
    flex-direction: column;
    padding: 0px 8px 0px 8px;
    color: var(--sprt-75);
    .summary-container-row {
      display: flex;
      padding: 5px 0px 6px 0px;
      border-bottom: 1px solid var(--sprt-85);
      .summary-container-row-title {
        flex: 2;
        .fc-control {
          color: var(--sprt-75);
        }
        .dropdown--main__text {
          color: var(--sprt-75);
        }
        p {
          //padding:10px 10px 0px 10px;
          margin-bottom: 0px;
        }
      }

      .summary-container-row-value {
        flex: 1;
        text-align: right;
        color: #282828;
      }
    }
  }
}
</style>
